import PropTypes from 'prop-types';
import {Icon} from 'semantic-ui-react';

function Document(props) {
  return (
    <a href={props.url} rel='noopener noreferrer' target='_blank'>
      <div className='text-center'>
        <Icon name={props.icon} size={props.size}/>
        <p>{props.name}</p>
      </div>
    </a>
  );
}

Document.defaultProps = {
  icon: 'file pdf outline',
  size: 'huge'
};

Document.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired
};


export default Document;
